import classnames from 'classnames';
import type { ComponentType, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandXXL, LabelM } from '@sorare/core/src/atoms/typography';

import fire from 'components/missions/Streaks/DetailsDialog/assets/fire.svg';

const Header = styled(Vertical)`
  padding: var(--unit) var(--triple-unit) var(--triple-unit);
`;

const Score = styled(BrandXXL)`
  position: relative;
  isolation: isolate;
  display: grid;
  text-shadow: 0 0 8px var(--c-nd-500);
  justify-items: end;
  > * {
    grid-area: 1 / 1;
  }
`;

const IconWrapper = styled.div`
  position: relative;
  z-index: -1;
  bottom: 0;
  right: calc(var(--double-and-a-half-unit) * -1);
  line-height: inherit;
  transform: rotate(15deg);
  width: max-content;
  &.gray {
    filter: grayscale(1);
  }
  > * {
    vertical-align: baseline;
    width: 36px;
    height: 36px;
  }
`;

type Props = {
  progress: number;
  LabelComponent?: ComponentType<PropsWithChildren>;
};

export const CurrentThresholdStreakHeader = ({
  progress,
  LabelComponent = LabelM,
}: Props) => {
  return (
    <Header gap={0} center>
      <Score>
        <span>{progress}</span>
        <IconWrapper className={classnames({ gray: progress === 0 })}>
          <img src={fire} alt="" width="36" height="36" />
        </IconWrapper>
      </Score>
      <LabelComponent>
        <FormattedMessage
          id="GameWeekly.UpcomingDialog.label"
          defaultMessage="GW Streak!"
        />
      </LabelComponent>
    </Header>
  );
};
